const proxySelectField = {
  id: "proxy_select",
  name: "form_author",
  type: "radio",
  label: "Who are you completing this form for?",
  hint: "For example, on behalf of a child or dependent",
  blank:
    "Select if you are completing this form on behalf of yourself or someone else",
  options: [
    {
      label: "Yourself",
      value: "myself",
    },
    {
      label: "Someone else",
      value: "someoneelse",
    },
  ],
  value: "myself",
  required: true,
};

const patientName = [
  {
    id: "patient_firstnames",
    name: "patient_firstnames",
    label: "First name",
    blank: "Enter your first names",
    type: "text",
    inputClass: "nhsuk-u-width-three-quarters",
    autocomplete: "given-name",
  },
  {
    id: "patient_lastname",
    name: "patient_lastname",
    label: "Last name",
    blank: "Enter your last name",
    type: "text",
    inputClass: "nhsuk-u-width-three-quarters",
    autocomplete: "family-name",
  },
];

const proxyPatientName = [
  {
    id: "patient_firstnames",
    name: "patient_firstnames",
    label: "First name",
    blank: "Enter the patient's first names",
    type: "text",
    inputClass: "nhsuk-u-width-three-quarters",
  },
  {
    id: "patient_lastname",
    name: "patient_lastname",
    label: "Last name",
    blank: "Enter the patient's last name",
    type: "text",
    inputClass: "nhsuk-u-width-three-quarters",
  },
];

const proxyName = [
  {
    id: "proxy_firstnames",
    name: "proxy_firstnames",
    label: "First name",
    blank: "Enter your first names",
    type: "text",
    inputClass: "nhsuk-u-width-three-quarters",
    autocomplete: "given-name",
  },
  {
    id: "proxy_lastname",
    name: "proxy_lastname",
    label: "Last name",
    blank: "Enter your last name",
    type: "text",
    inputClass: "nhsuk-u-width-three-quarters",
    autocomplete: "family-name",
  },
];

const nonProxyFields = [
  {
    id: "patient_name",
    name: "",
    label: "What is your name?",
    description: "",
    type: "divider",
    className: "nhsuk-fieldset__legend--s",
    inSection: [...patientName],
    required: true,
  },
  {
    id: "patient_dob",
    name: "patient_dob",
    label: "What is your date of birth?",
    hint: "For example, 31 3 1980",
    blank: "Enter your date of birth",
    type: "date",
    className: "nhsuk-fieldset__legend--s",
    autocomplete: "bday",
    required: true,
  },
  {
    id: "contact_sex",
    name: "contact_sex",
    label: "What is your sex?",
    hint: "As recorded on your medical record",
    blank: "Select your sex",
    type: "radio",
    options: [
      {
        label: "Male",
        value: "M",
      },
      {
        label: "Female",
        value: "F",
      },
      {
        label: "Other",
        value: "I",
      },
    ],
    required: true,
  },
  {
    id: "patient_postcode",
    name: "patient_postcode",
    label: "What is your postcode?",
    hint: "The one used to register with your GP",
    blank: "Enter your postcode",
    type: "text",
    labelClass: "nhsuk-label--s nhsuk-u-margin-bottom-3",
    inputClass: "nhsuk-input--width-10",
    autocomplete: "postal-code",
    required: true,
  },
  {
    id: "contact_phone",
    name: "contact_phone",
    label: "What is your phone number?",
    blank: "Enter your phone number",
    type: "phone",
    labelClass: "nhsuk-label--s nhsuk-u-margin-bottom-3",
    inputClass: "nhsuk-input--width-20",
    autocomplete: "tel-national",
    required: true,
  },
  {
    id: "contact_email",
    name: "contact_email",
    label: "What is your email address?",
    hint: "Anyone else with access to your email account may see responses sent to you",
    blank: "Enter your email address",
    type: "email",
    labelClass: "nhsuk-label--s nhsuk-u-margin-bottom-3",
    inputClass: "nhsuk-input--width-20",
    autocomplete: "email",
    required: true,
  },
];

const proxyFields = {
  patient: [
    {
      id: "patient_name",
      name: "",
      label: "What is the patient’s name?",
      description: "",
      type: "divider",
      className: "nhsuk-fieldset__legend--s",
      inSection: [...proxyPatientName],
      required: true,
    },
    {
      id: "patient_dob",
      name: "patient_dob",
      label: "What is the patient's date of birth?",
      hint: "For example, 31 3 1980",
      blank: "Enter the patient's date of birth",
      type: "date",
      className: "nhsuk-fieldset__legend--s",
      required: true,
    },
    {
      id: "contact_sex",
      name: "contact_sex",
      label: "What is the patient's sex?",
      hint: "As recorded on their medical record",
      blank: "Select the patient's sex",
      type: "radio",
      options: [
        {
          label: "Male",
          value: "M",
        },
        {
          label: "Female",
          value: "F",
        },
        {
          label: "Other",
          value: "I",
        },
      ],
      required: true,
    },
    {
      id: "patient_postcode",
      name: "patient_postcode",
      label: "What is the patient's postcode?",
      hint: "The one used to register with their GP",
      blank: "Enter the patient's postcode",
      type: "text",
      labelClass: "nhsuk-label--s nhsuk-u-margin-bottom-3",
      inputClass: " nhsuk-input--width-10",
      required: true,
    },
  ],
  proxy: [
    {
      id: "proxy_relationship",
      name: "proxy_relationship",
      label: "What is your relationship to the patient?",
      blank: "Select your relationship to the patient",
      type: "radio",
      options: [
        {
          label: "Parent",
          value: "Parent",
        },
        {
          label: "Guardian",
          value: "Guardian",
        },
        {
          label: "Spouse",
          value: "Spouse",
        },
        {
          label: "Carer",
          value: "Carer",
        },
        {
          label: "Son",
          value: "Son",
        },
        {
          label: "Daughter",
          value: "Daughter",
        },
        {
          label: "Sibling",
          value: "Sibling",
        },
        {
          label: "Other",
          value: "Other",
        },
      ],
      required: true,
    },
    {
      id: "proxy_name",
      name: "",
      label: "What is your name?",
      description: "",
      type: "divider",
      className: "nhsuk-fieldset__legend--s",
      inSection: [...proxyName],
      required: true,
    },
    {
      id: "proxy_dob",
      name: "proxy_dob",
      label: "What is your date of birth?",
      hint: "For example, 31 3 1980",
      blank: "Enter your date of birth",
      type: "date",
      className: "nhsuk-fieldset__legend--s",
      autocomplete: "bday",
      required: true,
    },
    {
      id: "proxy_sex",
      name: "proxy_sex",
      label: "What is your sex?",
      hint: "As recorded on your medical record",
      blank: "Select your sex",
      type: "radio",
      options: [
        {
          label: "Male",
          value: "M",
        },
        {
          label: "Female",
          value: "F",
        },
        {
          label: "Other",
          value: "I",
        },
      ],
      required: true,
    },
    {
      id: "proxy_postcode",
      name: "proxy_postcode",
      label: "What is your postcode?",
      hint: "The one used to register with your GP",
      blank: "Enter your postcode",
      type: "text",
      labelClass: "nhsuk-label--s nhsuk-u-margin-bottom-3",
      inputClass: "nhsuk-input--width-10",
      autocomplete: "postal-code",
      required: true,
    },
    {
      id: "contact_phone",
      name: "contact_phone",
      label: "What is your phone number?",
      blank: "Enter your phone number",
      type: "phone",
      labelClass: "nhsuk-label--s nhsuk-u-margin-bottom-3",
      inputClass: "nhsuk-input--width-20",
      autocomplete: "tel-national",
      required: true,
    },
    {
      id: "contact_email",
      name: "contact_email",
      label: "What is your email address?",
      hint: "Anyone else with access to your email account may see responses sent to you",
      blank: "Enter your email address",
      type: "email",
      labelClass: "nhsuk-label--s nhsuk-u-margin-bottom-3",
      inputClass: "nhsuk-input--width-20",
      autocomplete: "email",
      required: true,
    },
  ],
};

const preferredContact = {
  id: "preferred_contact",
  name: "item_meta[preferred_contact]",
  label: "How would you like to get reply notifications?",
  hint: "We will send you a confirmation message when you submit your form and when you have a response to view",
  blank: "Select how you would like to get reply notifications",
  type: "radio",
  options: [
    {
      label: "Email",
      value: "email",
    },
    {
      label: "Text message",
      value: "sms",
    },
    {
      label: "Both email and text message",
      value: "both",
    },
  ],
  required: true,
};

const requiredSpan =
  '<span class="nhsuk-tag nhsuk-tag--grey" aria-hidden="true">Required</span>';

const createFormGroup = (id = "") => {
  const formGroup = Object.assign(document.createElement("div"), {
    className: "frm_form_field frm_required_field nhsuk-form-group",
  });
  // Set the ID
  if (id) {
    formGroup.setAttribute("id", `frm_field_${id}_container`);
  }
  const errorCallback = (mutationList, observer) => {
    for (const list of mutationList) {
      // Error found
      if (list.addedNodes.length > 0) {
        for (const node of list.addedNodes) {
          if (node.classList.contains("frm_error")) {
            formGroup.classList.add("nhsuk-form-group--error");
            node.classList.add("nhsuk-error-message", "nhsuk-u-margin-top-2");
            for (const input of formGroup.getElementsByTagName("input")) {
              input.classList.add("nhsuk-input--error");
            }
          }
        }
      }
      // Error removed
      if (list.removedNodes.length > 0) {
        formGroup.classList.remove("nhsuk-form-group--error");
        for (const input of formGroup.getElementsByTagName("input")) {
          input.classList.remove("nhsuk-input--error");
        }
      }
    }
  };
  const observer = new MutationObserver(errorCallback);
  observer.observe(formGroup, { childList: true });
  return formGroup;
};

// Create a fieldset
const createFieldset = () => {
  const element = Object.assign(document.createElement("fieldset"), {
    className: "nhsuk-fieldset",
  });

  return element;
};

const createLegend = (props) => {
  const { className = "", innerHTML } = props;
  return Object.assign(document.createElement("legend"), {
    className: `nhsuk-fieldset__legend ${className}`,
    innerHTML,
  });
};

const createHint = ({ hint }) => {
  return Object.assign(document.createElement("div"), {
    innerHTML: hint,
    className: "nhsuk-hint",
  });
};

const createInput = (props) => {
  const {
    id,
    name,
    label,
    labelClass = "",
    inputClass = "",
    hint = "",
    type,
    autocomplete = "off",
    required = false,
    onchange = "",
    value = "",
  } = props;
  const formGroup = createFormGroup(id);

  formGroup.appendChild(
    Object.assign(document.createElement("label"), {
      className: "nhsuk-label",
      className: `nhsuk-label ${labelClass}`,
      innerHTML: required ? label + " " + requiredSpan : label,
      htmlFor: id,
    })
  );

  // Check for hint text
  if (hint) {
    formGroup.appendChild(createHint({ hint }));
  }

  const input = Object.assign(document.createElement("input"), {
    id: id,
    name: name,
    type: type !== "email" ? type : "text",
    className: `nhsuk-input ${inputClass}`,
    ariaRequired: "true",
    autocomplete: autocomplete,
    onchange: onchange,
    value: value,
  });

  formGroup.appendChild(input);

  return formGroup;
};

const createHidden = (props) => {
  return Object.assign(document.createElement("input"), {
    ...props,
    type: "hidden",
  });
};

const createRadio = (props) => {
  const {
    id,
    name,
    label,
    hint = "",
    options,
    onchange,
    value = "",
    required = false,
  } = props;
  // Create form group
  const formGroup = createFormGroup(id);
  // Create fieldset
  const fieldset = createFieldset();
  // Append legend
  fieldset.appendChild(
    createLegend({
      innerHTML: required ? label + " " + requiredSpan : label,
      className: " nhsuk-fieldset__legend--s",
    })
  );
  // Check for hint text
  if (hint) {
    fieldset.appendChild(createHint({ hint }));
  }
  // Create radios wrapper
  const radios = Object.assign(document.createElement("div"), {
    className: "frm_opt_container nhsuk-radios",
  });
  // Loop through options
  for (const [index, option] of options.entries()) {
    const itemId = `${id}-${index}`;
    // Create item wrapper
    const item = Object.assign(document.createElement("div"), {
      className: "nhsuk-radios__item",
    });
    // Create radio input
    item.appendChild(
      Object.assign(document.createElement("input"), {
        className: "nhsuk-radios__input",
        id: itemId,
        name: name,
        type: "radio",
        value: option.value,
        checked: value === option.value ? true : false,
        onchange,
      })
    );
    // Create label
    item.appendChild(
      Object.assign(document.createElement("label"), {
        className: "nhsuk-label nhsuk-radios__label",
        innerHTML: option.label,
        htmlFor: itemId,
      })
    );
    // Append option item
    radios.appendChild(item);
  }
  fieldset.appendChild(radios);
  formGroup.appendChild(fieldset);
  return formGroup;
};

// Create date field
export const createDate = (props) => {
  const {
    id,
    name,
    label,
    hint = "",
    className = "",
    autocomplete = "off",
    required = false,
    value = "",
  } = props;

  const formGroup = createFormGroup(id);

  const valueArray = value ? value.split("/") : ["", "", ""];

  // Create fieldset
  const fieldset = createFieldset();
  fieldset.appendChild(
    createLegend({
      innerHTML: required ? label + " " + requiredSpan : label,
      className: className,
    })
  );

  // Check for hint text
  if (hint) {
    fieldset.appendChild(createHint({ hint }));
  }

  // Create hidden field
  formGroup.append(
    createHidden({
      id: id,
      name: name,
      value: value,
    })
  );

  // Individual date fields
  const dateInput = Object.assign(document.createElement("div"), {
    className: "nhsuk-date-input",
  });

  const setDate = () => {
    const dayField = document.getElementById(`${id}-day`);
    const monthField = document.getElementById(`${id}-month`);
    const yearField = document.getElementById(`${id}-year`);

    let day = String(dayField.value).padStart(2, "0");
    let month = String(monthField.value).padStart(2, "0");
    let year = yearField.value;

    // Set the date
    document.getElementById(id).value = `${day}/${month}/${year}`;
  };

  const dateFields = [
    {
      id: `${id}-day`,
      name: `${id}-day`,
      label: "Day",
      type: "number",
      inputClass: "nhsuk-date-input__input nhsuk-input--width-2",
      autocomplete:
        autocomplete === "off" ? autocomplete : `${autocomplete}-day`,
      onchange: (e) => setDate(),
      onfocusout: (e) => setDate(),
      value: valueArray[0],
    },
    {
      id: `${id}-month`,
      name: `${id}-month`,
      label: "Month",
      type: "number",
      inputClass: "nhsuk-date-input__input nhsuk-input--width-2",
      autocomplete:
        autocomplete === "off" ? autocomplete : `${autocomplete}-month`,
      onchange: (e) => setDate(),
      onfocusout: (e) => setDate(),
      value: valueArray[1],
    },
    {
      id: `${id}-year`,
      name: `${id}-year`,
      label: "Year",
      type: "number",
      inputClass: "nhsuk-date-input__input nhsuk-input--width-4",
      autocomplete:
        autocomplete === "off" ? autocomplete : `${autocomplete}-year`,
      onchange: (e) => setDate(),
      onfocusout: (e) => setDate(),
      value: valueArray[2],
    },
  ];

  for (const date of dateFields) {
    const dateInputItem = Object.assign(document.createElement("div"), {
      className: "nhsuk-date-input__item",
    });
    dateInputItem.append(createInput(date));
    dateInput.append(dateInputItem);
  }

  fieldset.append(dateInput);
  formGroup.append(fieldset);
  return formGroup;
};

const createDivider = (props) => {
  const { label, inSection, className, required = false } = props;
  const fieldset = createFieldset();
  fieldset.appendChild(
    createLegend({
      className: className,
      innerHTML: required ? label + " " + requiredSpan : label,
    })
  );
  for (const field of inSection) {
    fieldset.append(createField(field));
  }
  return fieldset;
};

const createField = (props) => {
  const { type } = props;
  // switch through...
  switch (type) {
    case "text":
    case "email":
    case "postcode":
      return createInput(props);
    case "date":
      return createDate(props);
    case "phone":
      return createInput({
        ...props,
        type: "text",
        onchange: preferredContactCallback,
      });
    case "radio":
      return createRadio(props);
    case "hidden":
      return createHidden(props);
    case "select":
      return createSelect(props);
    case "divider":
      return createDivider(props);
    default:
      return Object.assign(document.createElement("p"), {
        innerHTML: "Unknown field type.",
      });
  }
};

// Create the patient ID fields based target class name
export const createPatientIdFields = () => {
  const { value } = proxySelectField;

  const proxy = document.querySelector(".sp_patient_identification");

  const nonProxy = document.querySelector(
    ".sp_patient_identification_non_proxy"
  );

  const nonSexClass = "non_sex";

  let fields = [];
  let container;

  if (nonProxy) {
    fields = nonProxyFields;
    container = nonProxy;
  }

  if (proxy) {
    container = proxy;
    fields.push();
    if (value === "myself") {
      fields = [
        { ...proxySelectField, onchange: proxySelectCallback },
        ...nonProxyFields,
      ];
    }
    if (value === "someoneelse") {
      fields = [
        { ...proxySelectField, onchange: proxySelectCallback },
        ...proxyFields.patient,
        ...proxyFields.proxy,
      ];
    }
  }

  if (fields.length > 0) {
    container.innerHTML = "";
    if (container.classList.contains(nonSexClass)) {
      fields = fields.map((field) => {
        if (field.id === "contact_sex" || field.id === "proxy_sex") {
          return { ...field, type: "hidden", value: "" };
        }
        return field;
      });
    }
    for (const field of fields) {
      container.appendChild(createField(field));
    }
    container.append(
      Object.assign(document.createElement("div"), {
        id: `${preferredContact.id}_wrapper`,
      })
    );
  }
};

// Proxy select callback
const proxySelectCallback = (el) => {
  proxySelectField.value = el.target.value;
  createPatientIdFields();
};

// Listen for mobile telephone number
const preferredContactCallback = (el) => {
  const preferredContactWrapper = document.getElementById(
    `${preferredContact.id}_wrapper`
  );
  const hasPreferredContact = document.getElementById(preferredContact.id);

  let mobileRegex = /((07)|((\+|00)447)){1}[0-9]{9}\b/;
  let isMobile = mobileRegex.test(el.target.value);

  if (isMobile && window.smsEnabled === "true") {
    if (hasPreferredContact) {
      return;
    }
    preferredContactWrapper.append(
      createField(preferredContact),
      Object.assign(document.createElement("input"), {
        type: "hidden",
        name: preferredContact.id,
        id: preferredContact.id,
      })
    );
  } else {
    preferredContactWrapper.innerHTML = "";
  }
};
